import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step_1_2 from "@/assets/integration-steps/reddit/step_1_2.png";

interface Props {
  stepLabel?: string;
}

const RedditIntegrationStep2 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step reddit-step-2">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>Wait for exclusion events</h6>
    </div>
    <div className="wrapper">
      <p>
        To create the Opticks audience,{" "}
        <b>
          Reddit Ads requires having received at least 50 exclusion events from
          Opticks
        </b>
        , so you might have to wait a few hours or days.
      </p>
      <p>
        You can see the current amount of events received by going to{" "}
        <OpticksLink
          href="https://ads.reddit.com/events-manager"
          label="Events Manager"
        />
        , and looking for the <b>"Custom: OpticksExcludeVisitor"</b> event.
      </p>
      <br />
      <img src={step_1_2} alt="Screenshot of step 1.2 Reddit Integration" />
      <br />
    </div>
  </div>
);

export default RedditIntegrationStep2;
